<template>
    <div class="d-flex flex-column justify-content-between h-100">
        <form class="form-fields" @submit.prevent="submitForm">
            <div
                v-if="!isSupportThread"
                class="d-flex justify-content-start align-items-end flex-wrap"
                style="gap: 1rem"
            >
                <Field
                    v-if="!isBroadcast"
                    class="col col-md-6"
                    label="Select Employee(s)"
                    type="multi-select"
                    :params="{
                        options: employeeOptions,
                    }"
                    v-model="recipientIds"
                ></Field>

                <Field
                    v-else
                    class="col col-md-6"
                    label="Select Employee(s)"
                    :disabled="true"
                    v-model="broadcastInputText"
                ></Field>

                <Field
                    class="col-md-5 pb-2"
                    label="Select All Employees"
                    type="checkbox"
                    @click="toggleBroadcast"
                    v-model="isBroadcast"
                ></Field>
            </div>

            <Field
                label="Subject"
                type="text"
                :params="{
                    placeholder: 'Message Title',
                }"
                :required="true"
                v-model="subject"
            ></Field>

            <Field
                label="Your Message"
                type="textarea"
                :params="{
                    placeholder: 'Your Message',
                }"
                :input-style="{
                    height: '8.375rem',
                }"
                :required="true"
                v-model="message"
            ></Field>

            <button
                class="btn btn-secondary w-100"
                style="margin-top: var(--space-6)"
                :disabled="sending"
            >
                <span
                    v-if="sending"
                    class="spinner-border spinner-border-sm me-2"
                ></span>
                Send
            </button>
        </form>
    </div>
</template>

<script>
import Field from '@/components/Field.vue';

import { useMessengerStore } from '@/stores/messenger';

export default {
    name: 'NewMessageForm',
    components: {
        Field,
    },
    props: {},
    emits: ['thread-created'],

    data() {
        return {
            employeeOptions: [],

            isBroadcast: false,
            recipientIds: [],
            subject: '',
            message: '',
            isSupportThread: false,

            preBroadcastRecipientIds: [], // backup for when broadcast is toggled

            sending: false,
            messengerStore: null,
        };
    },

    computed: {
        broadcastInputText() {
            return `All ${this.employeeOptions.length} employees`;
        },
    },

    watch: {},

    methods: {
        toggleBroadcast(isBroadcast) {
            if (isBroadcast) {
                this.preBroadcastRecipientIds = this.recipientIds;
                this.recipientIds = this.employeeOptions.map(
                    (option) => option.value
                );
            } else this.recipientIds = this.preBroadcastRecipientIds;
        },

        submitForm() {
            let payload = {
                subject: this.subject,
                message: this.message,
            };

            if (this.recipientIds.length) {
                payload.user_ids = this.recipientIds;
            }

            if (this.isSupportThread) {
                payload.is_support_thread = this.isSupportThread;
            }

            this.sending = true;
            this.$postData('message-thread/create', payload).then(
                (response) => {
                    if (response.success) {
                        this.$emit('thread-created', response.data.id);
                    } else if ('message' in response) {
                        this.$alertStore.pushError(response.message);
                    }
                    this.sending = false;
                }
            );
        },
    },

    mounted() {
        this.$userStore.sync(() => {
            this.$employeesStore.sync(() => {
                this.employeeOptions = this.$employeesStore.getEmployeeOptions([
                    this.$userStore.user.id,
                ]);
            });

            this.recipientIds = [...this.messengerStore.recipientIds];

            if (
                this.recipientIds.length == this.employeeOptions.length &&
                this.employeeOptions.length > 0
            ) {
                this.isBroadcast = true;
            }
        });
    },

    created() {
        this.messengerStore = useMessengerStore();
        this.subject = this.messengerStore.newThreadSubject || '';
        this.message = this.messengerStore.newThreadMessage || '';
        this.isSupportThread = this.messengerStore.isSupportThread || false;
    },
};
</script>

<style scoped>
.form-fields {
    display: flex;
    flex-direction: column;
    gap: var(--space-6);
}

hr {
    margin-bottom: var(--space-3);
    color: var(--neutral-600);
}
</style>
